<template>
  <div>
    <div v-if="!loading">
      <!-- text summaries -->
      <div class="d-flex flex-wrap ml--3" v-if="!wcLoading">
        <div class="ml-3 mt-2 mb-2" style="flex: 1 40%">
          <CompetitionTextSummary
            :showButton="false"
            :positiveSummary="selectSummaries.positiveSummary"
            :negativeSummary="selectSummaries.negativeSummary"
            :summariesUnavailable="Boolean(selectSummaries.summariesUnavailable)"
          />
        </div>

        <div class="flex-grow-1 ml-3 mt-2 mb-2">
          <CompetitionWordCloud
            @refreshDetails="$emit('refreshDetails')"
            v-if="selectWordCloud.length && !wcLoading"
          />
          <div class="card p-3 h-100" v-if="!selectWordCloud.length">- No data for wordcloud</div>
        </div>
      </div>
      <div class="d-flex" v-else>
        <b-skeleton height="160px" class="w-50 mr-3" />
        <b-skeleton height="160px" class="w-50" />
      </div>

      <!-- mentions over time -->
      <div class="d-flex flex-wrap mb-3 ml--3">
        <div class="ml-3 mt-2" style="flex: 1 60%">
          <CompetitionMentionsOverTime />
        </div>

        <!-- subcategories -->
        <div class="flex-grow-1 ml-3 mt-2" v-if="showExtraDetails">
          <CompetitionSubcategoryList
            :subcategories="selectSubcategories(selectDetailsFilterCategory._id)"
            @refreshDetails="$emit('refreshDetails')"
          />
        </div>
      </div>

      <!-- single row heatmap -->
      <div v-if="showExtraDetails">
        <CompetitionSingleLineHeatmap
          :subcategories="selectSubcategories(selectDetailsFilterCategory._id)"
          @refreshDetails="$emit('refreshDetails')"
        />
      </div>

      <!-- detailed list -->
      <CompetitionDetailsList />
    </div>

    <!-- loader -->
    <div v-else>
      <div v-for="index in 4" :key="index">
        <b-skeleton width="100%" height="200px" class="mb-4" />
      </div>
    </div>
  </div>
</template>

<script>
import CompetitionTextSummary from '../UI/CompetitionTextSummary.vue'
import CompetitionWordCloud from '../UI/CompetitionWordCloud.vue'
import CompetitionMentionsOverTime from '../UI/CompetitionMentionsOverTime.vue'
import CompetitionSubcategoryList from '../UI/CompetitionSubcategoryLIst.vue'
import CompetitionDetailsList from '../UI/CompetitionDetailsList.vue'
import CompetitionSingleLineHeatmap from '../UI/CompetitionSingleLineHeatmap.vue'

import { createNamespacedHelpers } from 'vuex'

const CompetitionDetailsModule = createNamespacedHelpers('competitionDetails')
const InsightsModule = createNamespacedHelpers('insightsv2')

export default {
  name: 'CompetitionDetails',
  props: ['loading', 'wcLoading'],
  components: {
    CompetitionTextSummary,
    CompetitionWordCloud,
    CompetitionMentionsOverTime,
    CompetitionSubcategoryList,
    CompetitionDetailsList,
    CompetitionSingleLineHeatmap
  },
  computed: {
    ...CompetitionDetailsModule.mapGetters([
      'selectSummaries',
      'selectWordCloud',
      'selectFilters',
      'selectDetailsFilterCategory'
    ]),
    ...InsightsModule.mapGetters(['selectSubcategories']),
    showExtraDetails() {
      return this.selectDetailsFilterCategory && !this.selectDetailsFilterCategory.path
    }
  }
}
</script>
